import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Row, Col, Container, Tabs, Tab, Dropdown, Badge } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import { Button, FormControl } from 'react-bootstrap';
import { connect } from 'react-redux';
// style
import s from './MenuList.css';
import rs from '../../../storeCommon.css';
// helpers
import messages from '../../../../locale/messages';
import debounce from '../../../../helpers/debounce';
// components
import CustomPagination from '../../../CustomPagination/CustomPagination';
import Link from '../../../Link/Link';
import ConfirmationPopup from '../../../Common/ConfirmationPopup';
import ItemList from '../ItemList/ItemList'; // Import ItemList
// images
import EditIcon from '../../../../../public/StoreIcon/edit.svg';
import TrashIcon from '../../../../../public/StoreIcon/dlty.svg';
import ManageItemIcon from '../../../../../public/StoreIcon/Manage-items.svg';
// redux action
import updateMenuStatus from '../../../../actions/shop/menu/updateMenuStatus';
import deleteMenu from '../../../../actions/shop/menu/deleteMenu';
import duplicateMenu from '../../../../actions/shop/menu/duplicateMenu';
import { openModal, closeModal } from '../../../../actions/siteadmin/modalActions';
import searchMenuAndItems from '../../../../actions/shop/menu/searchMenuAndItems';
import reorderMenus from '../../../../actions/shop/menu/reorderMenus';

import { FaPencil, FaTrashCan, FaBox, FaChevronUp, FaChevronDown, FaRegCopy } from 'react-icons/fa6'


class MenuList extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      currentPage: 1,
      searchList: '',
      typing: false,
      typingTimeout: 0,
      activeTab: 'menus',
      menuCurrentPage: 1,
      itemCurrentPage: 1,
      localMenuOrder: [],
      movingId: null,
      duplicatingMenuId: null,
    }
    this.paginationData = this.paginationData.bind(this);
    this.handleKeywordSearch = debounce(this.handleKeywordSearch.bind(this), 250);
    this.handleStatus = this.handleStatus.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDuplicateMenu = this.handleDuplicateMenu.bind(this)
    this.handleSelect = this.handleSelect.bind(this);
    this.menuPaginationData = this.menuPaginationData.bind(this);
    this.itemPaginationData = this.itemPaginationData.bind(this);
    this.handleMoveUp = this.handleMoveUp.bind(this);
    this.handleMoveDown = this.handleMoveDown.bind(this);
    this.cardRefs = {};
  }

  componentDidUpdate(prevProps) {
    const { menuDetails } = this.props;
    const prevResults = prevProps.menuDetails && prevProps.menuDetails.getAllMenu && prevProps.menuDetails.getAllMenu.results;
    const currResults = menuDetails && menuDetails.getAllMenu && menuDetails.getAllMenu.results;
    if (currResults && currResults !== prevResults) {
      this.setState({ localMenuOrder: [...currResults] });
    }
  }

  componentDidMount() {
    const { menuDetails } = this.props;
    const results = menuDetails && menuDetails.getAllMenu && menuDetails.getAllMenu.results;
    if (results) {
      this.setState({ localMenuOrder: [...results] });
    }
  }

  async handleMoveUp(index) {
    const { currentPage, localMenuOrder } = this.state;
    const { menuDetails: { refetch }, reorderMenus } = this.props;

    // Cross-page move: item is first on this page but page > 1
    if (index === 0 && currentPage > 1) {
      // Fetch the last item of the previous page
      const prevPageData = await refetch({ currentPage: currentPage - 1 });
      const prevPageResults =
        prevPageData &&
        prevPageData.data &&
        prevPageData.data.getAllMenu &&
        prevPageData.data.getAllMenu.results;
      if (!prevPageResults || prevPageResults.length === 0) return;

      const lastItemPrevPage = prevPageResults[prevPageResults.length - 1];
      const firstItemCurrPage = localMenuOrder[0];

      // Swap their sortOrders
      const payload = [
        { id: lastItemPrevPage.id, sortOrder: firstItemCurrPage.sortOrder },
        { id: firstItemCurrPage.id, sortOrder: lastItemPrevPage.sortOrder },
      ];
      await reorderMenus(payload);

      // Navigate to previous page so user sees the moved item
      const newPage = currentPage - 1;
      this.setState({ currentPage: newPage });
      refetch({ currentPage: newPage });
      return;
    }

    if (index === 0) return;

    this.setState(prevState => {
      const newOrder = [...prevState.localMenuOrder];
      [newOrder[index - 1], newOrder[index]] = [newOrder[index], newOrder[index - 1]];
      const payload = newOrder.map((menu, i) => ({ id: menu.id, sortOrder: i }));
      reorderMenus(payload);
      const movingId = newOrder[index - 1].id;
      // Scroll first, then flash highlight after scroll completes
      setTimeout(() => {
        const el = this.cardRefs[movingId];
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => {
          this.setState({ movingId });
          setTimeout(() => this.setState({ movingId: null }), 1000);
        }, 400);
      }, 0);
      return { localMenuOrder: newOrder, movingId: null };
    });
  }

  handleMoveDown(index) {
    this.setState(prevState => {
      if (index === prevState.localMenuOrder.length - 1) return null;
      const newOrder = [...prevState.localMenuOrder];
      [newOrder[index], newOrder[index + 1]] = [newOrder[index + 1], newOrder[index]];
      const payload = newOrder.map((menu, i) => ({ id: menu?.id, sortOrder: i }));
      this.props.reorderMenus(payload);
      const movingId = newOrder[index + 1].id;
      // Scroll first, then flash highlight after scroll completes
      setTimeout(() => {
        const el = this.cardRefs[movingId];
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => {
          this.setState({ movingId });
          setTimeout(() => this.setState({ movingId: null }), 1000);
        }, 400);
      }, 0);
      return { localMenuOrder: newOrder, movingId: null };
    });
  }

  handleSelect(key) {
    this.setState({ activeTab: key });
  }

  handleKeywordSearch(searchList) { // Keyword search
    const { menuDetails: { refetch }, searchMenuAndItems } = this.props;
    this.setState({ searchList, currentPage: 1, menuCurrentPage: 1, itemCurrentPage: 1 });
    if (searchList) {
      searchMenuAndItems({ searchList, menuPage: 1, itemPage: 1 });
    } else {
      refetch({ currentPage: 1, searchList });
    }
  }

  async handleDelete(id, currentPage) {
    const { deleteMenu, menuDetails: { refetch }, closeModal } = this.props;
    const variables = { currentPage };
    await deleteMenu(id, currentPage);
    await closeModal('menuDeleteModal')
    refetch(variables);
  };

  async handleDuplicateMenu(id, currentPage) {
    const { duplicateMenu, menuDetails: { refetch }, closeModal } = this.props;
    this.setState({ duplicatingMenuId: id });
    const newId = await duplicateMenu(id);
    // Refetch the query the component is actually watching so the new menu shows
    // up immediately without a manual refresh.
    if (newId) {
      await refetch({ currentPage });
    }
    this.setState({ duplicatingMenuId: null });
    closeModal('copyMenuModal');
  };

  paginationData(currentPage) {

    const { menuDetails: { refetch } } = this.props;
    const variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);

  };

  menuPaginationData(page) {
    const { searchMenuAndItems } = this.props;
    const { searchList, itemCurrentPage } = this.state;
    this.setState({ menuCurrentPage: page });
    searchMenuAndItems({ searchList, menuPage: page, itemPage: itemCurrentPage });
  }

  itemPaginationData(page) {
    const { searchMenuAndItems } = this.props;
    const { searchList, menuCurrentPage } = this.state;
    this.setState({ itemCurrentPage: page });
    searchMenuAndItems({ searchList, menuPage: menuCurrentPage, itemPage: page });
  }

  async handleStatus(id, status, currentPage) {
    const { updateMenuStatus, menuDetails: { refetch } } = this.props;
    const variables = { currentPage };
    await updateMenuStatus(id, status, currentPage);
    refetch(variables);
  };

  renderMenuActiveDays(menuOpenDay) {
    const { formatMessage } = this.props.intl;
    if (menuOpenDay.length <= 0) {
      return formatMessage(messages.noActiveDays)
    }

    const formatTime = (value) => {
      let hours = Math.floor(value);
      let minutesTime = Math.round((value - hours) * 60);
      let label = '';
      if (value === 0 || value === 24) {
        label = '12:00 AM';
      } else if (value === 0.5) {
        label = '12:30 AM';
      } else if (value >= 12 && value < 24) {
        label = (hours > 12 ? hours - 12 : hours) + ':' + (minutesTime === 0 ? '00' : (minutesTime < 10 ? '0' + minutesTime : minutesTime)) + ' PM';
      } else {
        label = (hours === 0 ? 12 : hours) + ':' + (minutesTime === 0 ? '00' : (minutesTime < 10 ? '0' + minutesTime : minutesTime)) + ' AM';
      }
      return label;
    };

    const dayOrder = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    // Sort input if needed (usually already sorted by DB)
    const sortedDays = [...menuOpenDay].sort((a, b) => dayOrder.indexOf(a.operationDay) - dayOrder.indexOf(b.operationDay));

    const getScheduleKey = (day) => {
      if (day.isWholeDay === true) return 'wholeDay';
      if (!day.timeSlot || day.timeSlot.length === 0) return 'wholeDay';
      return day.timeSlot.map(s => `${s.startTime}-${s.endTime}-${s.isNextDay}`).join('|');
    };

    const groups = [];
    if (sortedDays.length > 0) {
      let currentGroup = {
        days: [sortedDays[0]],
        key: getScheduleKey(sortedDays[0])
      };

      for (let i = 1; i < sortedDays.length; i++) {
        const currentDay = sortedDays[i];
        const currentKey = getScheduleKey(currentDay);
        const prevDayOrder = dayOrder.indexOf(sortedDays[i - 1].operationDay);
        const currentDayOrder = dayOrder.indexOf(currentDay.operationDay);

        // Check if consecutive and same schedule
        if (currentKey === currentGroup.key && currentDayOrder === prevDayOrder + 1) {
          currentGroup.days.push(currentDay);
        } else {
          groups.push(currentGroup);
          currentGroup = {
            days: [currentDay],
            key: currentKey
          };
        }
      }
      groups.push(currentGroup);
    }

    const renderSchedule = (day, key) => {
      if (key === 'wholeDay') return <span style={{ fontWeight: 'bold' }}>{formatMessage(messages.allHours)}</span>;
      return day.timeSlot.map((slot, sIdx) => (
        <span key={sIdx} style={{ fontWeight: 'bold' }}>
          {formatTime(slot.startTime)} - {formatTime(slot.endTime)}
          {slot.isNextDay && ' (Next Day)'}
          {sIdx < day.timeSlot.length - 1 ? ', ' : ''}
        </span>
      ));
    };

    return (
      <details>
        <summary>{formatMessage(messages.activeDays)}</summary>
        <ul style={{ margin: 0, paddingLeft: '20px', display: 'inline-block' }}>
          {groups.map((group, gIdx) => {
            const firstDay = group.days[0].operationDay;
            const lastDay = group.days[group.days.length - 1].operationDay;
            const dayLabel = group.days.length > 1
              ? `${formatMessage(messages[firstDay])} - ${formatMessage(messages[lastDay])}`
              : formatMessage(messages[firstDay]);

            return (
              <li key={gIdx}>
                {dayLabel}: {renderSchedule(group.days[0], group.key)}
              </li>
            );
          })}
        </ul>
      </details>
    )
  }


  render() {
    const { menuDetails, openModal, closeModal, menuDeleteModal, copyMenuModal, modalData, isEnableAddon, searchResults } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage, searchList, activeTab, menuCurrentPage, itemCurrentPage, localMenuOrder, movingId, duplicatingMenuId } = this.state;

    const renderMenuList = (menus, isReorderable = false) => {
      return menus.map((menu, index) => {
        const getOpenDay = menu.menuAvailability.filter(i => (i.isOpen === true));
        return (
          <Row key={menu.id} ref={el => { this.cardRefs[menu.id] = el; }}>
            <Col xs={12} lg={12} md={12} sm={12}>
              <div className={cx(rs.menuItemGrid, { [s.menuReordering]: menu.id === movingId })}>
                <div className={cx('d-flex justify-content-between align-items-center p-4 bg-light')}>
                  <div className={cx(rs.alignLeft, rs.tabSection, 'textAlignRightRTL')}>
                    <p className={cx(rs.idTitle, rs.textOverFlow, { 'text-muted': !menu.isEnable })}>
                      {menu.menuName}
                    </p>
                  </div>

                  <div className='d-flex align-items-center' style={{ gap: '1em' }}>
                    <div className={cx(rs.alignRightText, rs.manageItemBtn, 'd-none d-md-inline')}>
                      <Link to={`/store/menu/${menu.id}/item`} className={'btn btn-danger'}>
                        <img src={ManageItemIcon} className={cx(s.iconsWidthManageItem, 'iconsWidthManageItemRTL')} alt='manage item icon' />
                        <span className={s.vtrMiddle}>{formatMessage(messages.manageItem)}</span>
                      </Link>
                    </div>

                    <Dropdown>
                      <Dropdown.Toggle variant={"default"} id={`dropdown-menu-edit-${menu.id}`}>
                        {formatMessage(messages.editItem)}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item as={Link} to={`/store/menu/${menu.id}/item`} className='d-md-none d-block'>
                          <span className='btn btn-danger'><FaBox /> {formatMessage(messages.manageItem)}</span>
                        </Dropdown.Item>
                        <Dropdown.Header>Menu Active Status</Dropdown.Header>
                        <Dropdown.ItemText>
                          <select value={menu.isEnable}
                            onChange={(e) => { this.handleStatus(menu.id, e.target.value, currentPage) }}
                            className={cx(rs.activeSelect, rs.storeSelectInput)}>
                            <option value={true}>{formatMessage(messages.active)}</option>
                            <option value={false}>{formatMessage(messages.inactive)}</option>
                          </select>
                        </Dropdown.ItemText>
                        <Dropdown.Header>Edit or Remove</Dropdown.Header>
                        <Dropdown.Item as={Link} to={`/store/menu/edit/${menu.id}`}>
                          <FaPencil /> {formatMessage(messages.editItem)}
                        </Dropdown.Item>
                        <Dropdown.Item href={`#copy/${menu.id}`}
                          disabled={duplicatingMenuId === menu.id}
                          onClick={() => openModal('copyMenuModal', { id: menu.id, modalName: 'copyMenuModal', currentPage })}>
                          {duplicatingMenuId === menu.id
                            ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                            : <FaRegCopy />} {formatMessage(messages.duplicateMenu)}
                        </Dropdown.Item>
                        <Dropdown.Item href={`#delete/${menu.id}`}
                          onClick={() => openModal('menuDeleteModal', { id: menu.id, modalName: 'menuDeleteModal', currentPage })}>
                          <FaTrashCan /> <span className={'text-danger'}>{formatMessage(messages.deleteAction)}</span>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    {isReorderable && (
                      <div className='d-flex flex-column' style={{ gap: '2px' }}>
                        <Button
                          variant='outline-secondary'
                          size='sm'
                          disabled={index === 0 && currentPage <= 1}
                          onClick={() => this.handleMoveUp(index)}
                          title='Move up'
                          style={{ padding: '2px 6px', lineHeight: 1 }}
                        >
                          <FaChevronUp />
                        </Button>
                        <Button
                          variant='outline-secondary'
                          size='sm'
                          disabled={index === menus.length - 1}
                          onClick={() => this.handleMoveDown(index)}
                          title='Move down'
                          style={{ padding: '2px 6px', lineHeight: 1 }}
                        >
                          <FaChevronDown />
                        </Button>
                      </div>
                    )}

                  </div>
                </div>

                <div className='p-4'>
                  <div>
                    Total: {menu.itemCount} items
                  </div>
                  <div>
                    Status: {menu.isEnable ?
                      <Badge variant='success'>{formatMessage(messages.active)}</Badge> :
                      <Badge variant='secondary'>{formatMessage(messages.inactive)}</Badge>}
                  </div>

                  {this.renderMenuActiveDays(getOpenDay)}
                </div>
              </div>
            </Col>
          </Row>
        )
      })
    };

    return (
      <div className={'mainContainer'}>
        <div>
          <ConfirmationPopup
            modalStatus={menuDeleteModal}
            title={formatMessage(messages.deleteMenuTitle)}
            body={formatMessage(messages.deleteConfirmation)}
            closeModal={() => closeModal('menuDeleteModal')}
            popupButtonLeftName={formatMessage(messages.cancelButton)}
            popupButtonRightName={formatMessage(messages.deleteAction)}
            popupButtonLeftFunction={() => closeModal('menuDeleteModal')}
            popupButtonRightFunction={() => this.handleDelete(modalData.id, modalData.currentPage)}
          />
          <ConfirmationPopup
            modalStatus={copyMenuModal}
            loading={duplicatingMenuId !== null}
            title={formatMessage(messages.copyMenuTitle)}
            body={formatMessage(messages.copyMenuConfirmation)}
            closeModal={() => closeModal('copyMenuModal')}
            popupButtonLeftName={formatMessage(messages.cancelButton)}
            popupButtonRightName={formatMessage(messages.duplicateMenu)}
            popupButtonLeftFunction={() => closeModal('copyMenuModal')}
            popupButtonRightFunction={() => this.handleDuplicateMenu(modalData.id, modalData.currentPage)}
          />
        </div>
        <Container fluid>
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <h1 className={cx(rs.storeTitleText, 'textAlignRightRTL')}>{formatMessage(messages.manageMenu)}</h1>
            </Col>
            <Col lg={12} md={12} sm={12} xs={12}>
              <div className={cx(rs.searchInputStore, s.verticalTopPad, s.floatLeft, 'floatRightRTL')}>
                <FormControl type='text' placeholder={formatMessage(messages.search)} onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)} className={cx(rs.formControlInputStore, rs.searchInputWidth, 'formControlInputStoreRTL')} />
              </div>
              <div className={cx(s.displayInlineBlock, rs.searchTopBtn, s.floatRight, 'floatLeftRTL')}>
                {Number(isEnableAddon) === 1 && <Link to={"/store/menu/modifier-groups"} className={cx(rs.button, rs.btnPrimaryBorder, s.displayInlineBlock, s.modifierGroupBtn, 'modifierGroupBtnRTL')}>{formatMessage(messages.modifierGroup)}</Link>}
                <Link to={"/store/menu/add"} className={cx(rs.button, rs.btnPrimary, s.displayInlineBlock)}>{formatMessage(messages.addMenu)}</Link>
              </div>
            </Col>
          </Row>
          {
            searchList ? (
              <Tabs activeKey={activeTab} onSelect={this.handleSelect} id="menu-item-tabs">
                <Tab eventKey="menus" title="Menus">
                  {
                    searchResults && searchResults.menus && searchResults.menus.results.length > 0 ?
                      renderMenuList(searchResults.menus.results) : <span className={rs.notFoundText}><FormattedMessage {...messages.noMenu} />.</span>
                  }
                  {
                    searchResults && searchResults.menus && searchResults.menus.count > 10 &&
                    <div className={cx(s.space5, s.spaceTop5, 'store')}>
                      <CustomPagination
                        total={searchResults.menus.count}
                        currentPage={menuCurrentPage}
                        defaultCurrent={1}
                        defaultPageSize={10}
                        change={this.menuPaginationData}
                        paginationLabel={searchResults.menus.count > 1 ? formatMessage(messages.menus) : formatMessage(messages.menu)}
                      />
                    </div>
                  }
                </Tab>
                <Tab eventKey="items" title="Items">
                  {
                    searchResults && searchResults.items && searchResults.items.results.length > 0 ?
                      <ItemList
                        itemDetails={{
                          getAllSubMenu: { results: [{ id: 'searchResults', isEnable: true, item: searchResults.items.results }] },
                          refetch: () => this.props.searchMenuAndItems({ searchList, menuPage: menuCurrentPage, itemPage: itemCurrentPage })
                        }}
                        hideSearchAndPagination={true}
                      /> : <span className={rs.notFoundText}><FormattedMessage {...messages.noItem} />.</span>
                  }
                  {
                    searchResults && searchResults.items && searchResults.items.count > 10 &&
                    <div className={cx(s.space5, s.spaceTop5, 'store')}>
                      <CustomPagination
                        total={searchResults.items.count}
                        currentPage={itemCurrentPage}
                        defaultCurrent={1}
                        defaultPageSize={10}
                        change={this.itemPaginationData}
                        paginationLabel={searchResults.items.count > 1 ? "Items" : "Item"}
                      />
                    </div>
                  }
                </Tab>
              </Tabs>
            ) : (
              <>
                {
                  localMenuOrder.length > 0 ? renderMenuList(localMenuOrder, true) : (menuDetails && menuDetails.getAllMenu && menuDetails.getAllMenu.results && menuDetails.getAllMenu.results.length > 0 && renderMenuList(menuDetails.getAllMenu.results, true))
                }
                {
                  menuDetails && menuDetails.getAllMenu && menuDetails.getAllMenu.results && menuDetails.getAllMenu.results.length === 0 &&
                  <span className={rs.notFoundText}><FormattedMessage {...messages.noMenu} />.</span>
                }
                {
                  menuDetails && menuDetails.getAllMenu && menuDetails.getAllMenu.results && menuDetails.getAllMenu.results.length > 0
                  && <div className={cx(s.space5, s.spaceTop5, 'store')}>
                    <CustomPagination
                      total={menuDetails.getAllMenu.count}
                      currentPage={currentPage}
                      defaultCurrent={1}
                      defaultPageSize={10}
                      change={this.paginationData}
                      paginationLabel={menuDetails.getAllMenu.count > 1 ? formatMessage(messages.menus) : formatMessage(messages.menu)}
                    />
                  </div>
                }
              </>
            )
          }
        </Container>
      </div>
    );
  }
}

const mapDispatch = {
  deleteMenu,
  updateMenuStatus,
  duplicateMenu,
  openModal,
  closeModal,
  searchMenuAndItems,
  reorderMenus,
};

const mapState = (state) => ({
  menuDeleteModal: state.modalStatus.menuDeleteModal,
  copyMenuModal: state.modalStatus.copyMenuModal,
  modalData: state.modalStatus.data && state.modalStatus.data[0],
  isEnableAddon: state.siteSettings.data.modifiers,
  searchResults: state.menu.searchResults,
});

export default injectIntl(withStyles(s, rs)(connect(mapState, mapDispatch)(MenuList)));
